import PropTypes from "prop-types";
import Menu01Icon from "@untitled-ui/icons-react/build/esm/Menu01";
import {
    Avatar,
    Box, Button,
    Chip,
    Drawer,
    IconButton, Menu,
    Stack,
    SvgIcon, Typography,
    useMediaQuery,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { AccountButton } from "../account-button";
import SwitchBrand from "../../../components/SwitchBrand";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router";
import { getFirestore, doc } from "../../../lib/firebase";
import { BRAND_COLLECTION } from "../../../utils/constants";
import { useDocumentData } from "react-firebase-hooks/firestore";
import localStrings from "../../../localStrings";
import SelectorPeriod from "../selectorPeriod/selectorPeriod";
import DateRangeIcon from '@mui/icons-material/DateRange';
import {usePopover} from "../../../hooks/use-popover";
import {SettingsButton} from "../../../components/settings/settings-button";
import useSettings from "../../../hooks/useSettings";
import TuneIcon from '@mui/icons-material/Tune';
import {SettingsDrawer} from "../../../components/settings/settings-drawer";
import React, {useState} from "react";
import {useDisplaySettings} from "../../../hooks/use-display-settings";
import moment from "moment/moment";
import {filterMonth, filterSingleDay, filterWeek, filterYear} from "../../../pages/Home/FilterInfoOverview";
import DateSelectorDialogMobile from "../../../components/DateSelectorDialogMobile";

const TOP_NAV_HEIGHT = 64;
const TOP_NAV_HEIGHT_MOBILE = 56;
const SIDE_NAV_WIDTH = 280;

moment.locale('fr');

export function getTopBarHeight(lgUp) {
    if (lgUp) {
        return TOP_NAV_HEIGHT;
    }
    return TOP_NAV_HEIGHT_MOBILE; // Hauteur pour mobile
}


export const TopNav = (props) => {
    const [openDatePicker, setOpenDatePicker] = useState(false)

    const { onMobileNavOpen, ...other } = props;
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    const popover = usePopover();
    const { superAdmin, userInDb, currentBrand } = useAuth();
    const navigate = useNavigate();
    const settings = useDisplaySettings();
    const db = getFirestore();
    const { filter } = useAuth();
    const refBrand = doc(db, BRAND_COLLECTION, currentBrand()?.id || "-1");
    const [brandDb] = useDocumentData(refBrand, {
        snapshotListenOptions: { includeMetadataChanges: true },
    });

    function getCredit() {
        return brandDb?.credit ? `${parseFloat(brandDb.credit)} ${localStrings.credits}` : "";
    }

    function getFormattedDate() {
        const date = moment(filter?.singleDay?.toDate());
        switch (filter.filterType) {
            case filterSingleDay:
                return date.format("ll")
            case filterWeek:
                return localStrings.formatString(localStrings.weekNumber, date.week())
            case filterMonth:
                return date.format('MMMM YYYY')
            case filterYear:
                return date.format('YYYY')
            default:
                return null;
        }
    }

    return (
        <>


            <Box
                component="header"
                sx={{
                    backdropFilter: "blur(6px)",
                    backgroundColor: (theme) => alpha(theme.palette.background.default, 0.8),
                    // position: "sticky",
                    position: 'fixed',
                    left: {
                        lg: `${SIDE_NAV_WIDTH}px`,
                    },
                    top: 0,
                    width: {
                        lg: `calc(100% - ${SIDE_NAV_WIDTH}px)`,
                        xs: "100%", // Pleine largeur sur mobile
                    },
                    zIndex: (theme) => theme.zIndex.appBar,
                }}
                {...other}
            >

                <DateSelectorDialogMobile
                    openDatePicker={openDatePicker}
                    setOpenDatePicker={setOpenDatePicker}
                />

                <SettingsDrawer
                    canReset={settings.isCustom}
                    onClose={settings.handleDrawerClose}
                    onReset={settings.handleReset}
                    onUpdate={settings.handleUpdate}
                    open={settings.openDrawer}
                    values={{
                        colorPreset: settings.colorPreset,
                        contrast: settings.contrast,
                        direction: settings.direction,
                        paletteMode: settings.paletteMode,
                        responsiveFontSizes: settings.responsiveFontSizes,
                        stretch: settings.stretch,
                        layout: settings.layout,
                        navColor: settings.navColor
                    }}
                />

                <Stack
                    alignItems="center"
                    direction="row"
                    justifyContent="space-between"
                    spacing={2}
                    sx={{
                        minHeight: TOP_NAV_HEIGHT,
                        px: 2,
                        width: "100%",
                    }}
                >
                    {/* Menu Burger sur Mobile */}
                    {!lgUp && (
                        <IconButton onClick={onMobileNavOpen}>
                            <SvgIcon>
                                <Menu01Icon />
                            </SvgIcon>
                        </IconButton>
                    )}

                    {/* Section de droite : Adaptée pour mobile */}
                    <Stack
                        alignItems="center"
                        direction="row"
                        spacing={lgUp ? 2 : 1}
                        sx={{
                            flexGrow: 1,
                            justifyContent: "flex-end",
                        }}
                    >
                        {(superAdmin ||
                            (userInDb?.allowedBrandIds &&
                                userInDb.allowedBrandIds.length > 0 &&
                                !(userInDb?.allowedBrandIds.length === 1 &&
                                    userInDb?.allowedBrandIds[0] === userInDb.brandId))) && (
                            <SwitchBrand />
                        )}

                        {currentBrand()?.useChargeOnline && (
                            <Chip
                                onClick={() => navigate("/dashboard/account", { replace: true })}
                                avatar={<Avatar sx={{ width: 24, height: 24 }}>¤</Avatar>}
                                label={getCredit()}
                                variant="outlined"
                                sx={{ fontSize: lgUp ? "1rem" : "0.75rem", p: 1 }} // Ajustement mobile
                            />
                        )}

                        {lgUp ?
                            <SelectorPeriod />
                            :
                            <Button
                                onClick={() => setOpenDatePicker(true)}
                                startIcon={<DateRangeIcon />}
                                fullWidth
                                variant="outlined">
                                <Typography

                                    sx={{
                                        cursor: 'pointer',
                                        fontSize: '0.875rem',
                                        fontWeight: 500,
                                        textAlign: 'center',
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 1,
                                    }}
                                >
                                    {getFormattedDate()}
                                </Typography>
                            </Button>
                        }

                        {lgUp &&
                            <IconButton onClick={settings.handleDrawerOpen}>
                                <TuneIcon/>
                            </IconButton>
                        }

                        <AccountButton />
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};

TopNav.propTypes = {
    onMobileNavOpen: PropTypes.func,
};
